import { render, staticRenderFns } from "./zonghe.vue?vue&type=template&id=2719ab2a&scoped=true"
import script from "./zonghe.vue?vue&type=script&lang=js"
export * from "./zonghe.vue?vue&type=script&lang=js"
import style0 from "./zonghe.vue?vue&type=style&index=0&id=2719ab2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2719ab2a",
  null
  
)

export default component.exports